import React from 'react';

const ACTIONS = [
  {icon: '🎩', label: 'Tutor', key: 'tutor'},
  {icon: '✈️', label: 'Fly', key: 'fly'},
  {icon: '💺', label: 'Sit', key: 'sit'},
  {icon: '🔫', label: 'Laser', key: 'laser'},
  {icon: '🦘', label: 'Jump', key: 'jump'},
  {icon: '❓', label: 'Help', key: 'help'},
];

const LCVActionSidebar = ({tutorChatOpen, onToggleTutorChat}) => {
  return (
    <div className="lcv-action-sidebar">
      {ACTIONS.map(action => (
        <button
          key={action.key}
          className={`lcv-action-btn ${action.key === 'tutor' && tutorChatOpen ? 'lcv-action-btn-active' : ''}`}
          onClick={action.key === 'tutor' ? onToggleTutorChat : undefined}
        >
          <span className="lcv-action-icon">{action.icon}</span>
          <span className="lcv-action-label">{action.label}</span>
        </button>
      ))}
    </div>
  );
};

export default LCVActionSidebar;
